var scCrisisHero = scCrisisHero || {};

if (!Object.create) {
    Object.create = (function () {
        function F() {}

        return function (o) {
            if (arguments.length !== 1) {
                throw new Error("Object.create implementation only accepts one parameter.");
            }
            F.prototype = o;
            return new F();
        };
    })();
}

jQuery(function ( $ ) {
 
    $.fn.crisisHero = function( options ) {
        return this.each(function() {
            var crisisHero = Object.create(scCrisisHero.crisisHero);
            
            crisisHero.init(this, options);

        });
    };

    $.fn.crisisHero.options = {
            
    };

    scCrisisHero.crisisHero = {
        
        init (elem, options) {
            var self = this;
            self.$container = $(elem);
            self.options = $.extend({}, $.fn.showHide.options, options);
            
            self.$bgImage = self.$container.find(".crisis-landing-wrap__outer");
            self.$loader = self.$container.find(".crisis-loader");

            self.$close = self.$container.find(".crisis-mobile-close");
            
            $("body").addClass("no-scroll");
            
            self.setImage();

            self.bindElements();

            
        },

        bindElements () {
            var self = this;
            
            
            self.$close.click(function() {
                self.animateOut();
            });

            self.$container.on("mousewheel", function(e) { 
                if(e.originalEvent.wheelDelta /120 < 0) {
                    self.animateOut();
                    return false;
                };
            });

            var lastY = 0;
            
            
            self.$container.on("touchmove", function(e) {
                e.preventDefault();
                var currentY = e.originalEvent.touches[0].clientY;
                if(currentY > lastY){
                   self.animateOut();
                }
                lastY = currentY;
            });
        },

        setImage () {
            var self = this;
            var image = new Image();
            image.onload = function() {
                self.$bgImage[0].style.backgroundImage = "url("+this.src+")";
                self.animateIn();
            };
            
            image.onerror = function() {
                self.animateOut();
            };
            
            image.src = self.$bgImage.attr("data-bgImage");
        },

        animateIn() {
            var self = this;
            self.$loader.addClass("hide-loader");
            setTimeout( function() {
                self.$container.addClass("animate-in");
                self.$loader.remove();
                $("body").removeClass("no-scroll");
            }, 700);
        },
        animateOut () {
            var self = this;

            self.$container.addClass("animate-out");
            setTimeout( function() {
                self.$container.remove();
                Waypoint.refreshAll();
                $("body").removeClass("no-scroll");
            }, 1700 );
        }
    }
});
